import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { EquipmentTypeSelectorComponent } from './equipment-type-selector/equipment-type-selector.component';
import {
  SiteService,
  AssetService,
  PointService,
  EquipmentService,
  SpatialAssetService,
  RoleService,
  LaunchDarklyService
} from '../context-discovery-services/services';
import { AssetsGridComponent } from './assets-grid/assets-grid.component';
import { PolymerModule } from '@codebakery/origami';
import { AllPointsComponent } from './all-points/all-points.component';
import { LoadingComponent } from './loading/loading.component';
import { GenericFilterComponent } from './generic-filter/generic-filter.component';
import { EquipmentSelectorComponent } from './equipment-selector/equipment-selector.component';
import { AddPointsToAssetComponent } from './add-points-to-asset/add-points-to-asset.component';
import { CreateNewAssetComponent } from './create-new-asset/create-new-asset.component';
import { RenameAssetComponent } from './rename-asset/rename-asset.component';
import { AssignLocationComponent } from './assign-location/assign-location.component';
import { ConfigurePointComponent } from './configure-point/configure-point.component';
import { WidgetComponent } from './widget/widget.component';

@NgModule({
  imports: [CommonModule, PolymerModule],
  exports: [LayoutComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [LayoutComponent,
    EquipmentTypeSelectorComponent,
    AssetsGridComponent,
    AllPointsComponent,
    LoadingComponent,
    GenericFilterComponent,
    EquipmentSelectorComponent,
    AddPointsToAssetComponent,
    CreateNewAssetComponent,
    RenameAssetComponent,
    AssignLocationComponent,
    ConfigurePointComponent,
    WidgetComponent
  ],
  providers: [
    SiteService,
    AssetService,
    PointService,
    EquipmentService,
    SpatialAssetService,
    RoleService,
    LaunchDarklyService
  ]
})
export class IdentifyAssetsModule { }
